import { debounce } from "instantsearch.js/es/lib/utils";

export const getQueryId = () => {
  const windowLocation = new URL(window.location.href);
  const queryId = windowLocation.searchParams.get("queryID");
  return queryId;
};

export const addToDataLayer = (event) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);
};

export const debouncedAddToDataLayer = debounce(
  (event) => addToDataLayer(event),
  500
);

export const addToDataLayerWithEcommerce = (event) => {
  addToDataLayer({ ecommerce: null });
  addToDataLayer(event);
};

export const addToCart = (gtmProduct, fromSource = '', algoliaSearchQueryId = '') => {
  try {
    const objectData = [{ "price": gtmProduct.price, "quantity": gtmProduct.quantity }];
    if (fromSource === 'ProductCardQuickAdd') {
      addToDataLayer({ algoliaObjectIds: null, algoliaObjectData: null, algoliaObjectData: null });
      addToDataLayer({
        event: "algolia_quick_add_to_cart_after_search",
        algoliaObjectIds: [gtmProduct.algoliaId],
        algoliaQueryId: algoliaSearchQueryId,
        algoliaIndexName: window.__litium.algoliaSettings.indexName,
        algoliaCurrencyCode: window.__litium.preloadState.cart.currency,
        algoliaValue: gtmProduct.price * gtmProduct.quantity,
        algoliaObjectData: objectData,
      });
    } else {
      const queryId = getQueryId();
      if (queryId) {
        addToDataLayer({ algoliaObjectIds: null, algoliaObjectData: null, algoliaObjectData: null });
        addToDataLayer({
          event: "algolia_add_to_cart_after_search",
          algoliaObjectIds: [gtmProduct.algoliaId],
          algoliaQueryId: queryId,
          algoliaIndexName: window.__litium.algoliaSettings.indexName,
          algoliaCurrencyCode: window.__litium.preloadState.cart.currency,
          algoliaValue: gtmProduct.price * gtmProduct.quantity,
          algoliaObjectData: objectData,
        });
      } else {
        addToDataLayer({ algoliaObjectIds: null, algoliaObjectData: null, algoliaObjectData: null });
        addToDataLayer({
          event: "algolia_add_to_cart",
          algoliaObjectIds: [gtmProduct.algoliaId],
          algoliaIndexName: window.__litium.algoliaSettings.indexName,
          algoliaCurrencyCode: window.__litium.preloadState.cart.currency,
          algoliaValue: gtmProduct.price * gtmProduct.quantity,
          algoliaObjectData: objectData,
        });
      }
    }
  } catch (error) {
    console.error(error);
  }
}
